import { PageType } from './routing';

// Define types for our header heights configuration
type DeviceHeights = {
    mobile: string;
    desktop: string;
};

type HeaderHeightsConfig = {
    main: DeviceHeights;
    compact: DeviceHeights;
    default: DeviceHeights;
    [key: string]: DeviceHeights; // Allow string indexing
};

/**
 * Configuration object that maps page types to header heights for different device types.
 * Add new heights here when adding new page types.
 */
export const HEADER_HEIGHTS: HeaderHeightsConfig = {
    main: {
        mobile: 'h-[321px]',
        desktop: 'h-[804px]',
    },
    compact: {
        mobile: 'h-[70px]',
        desktop: 'h-[151px]',
    },
    default: {
        mobile: 'h-[159px]',
        desktop: 'h-[452px]',
    },
};

/**
 * Determines the header height based on the page type and device type.
 * @param pageType - The type of page ('main', 'recipe', or 'default')
 * @param isMobile - Whether the current device is mobile
 * @returns The header height CSS class
 */
export const getHeaderHeight = (pageType: PageType, isMobile: boolean): string => {
    const deviceType = isMobile ? 'mobile' : 'desktop';

    if (HEADER_HEIGHTS[pageType]) {
        return HEADER_HEIGHTS[pageType][deviceType];
    }

    return HEADER_HEIGHTS.default[deviceType];
};
